import consumer from "./consumer"
import SlimSelect from "slim-select"

consumer.subscriptions.create("LookupUpdatesChannel", {
  connected() {
    console.log("Connected to LookupUpdatesChannel");
  },

  disconnected() {
    console.log("Disconnected from LookupUpdatesChannel");
  },

  received(data) {
    console.log("LookupUpdatesChannel received:", data);
    
    // Find the lookup field that matches this block
    const lookupField = document.querySelector(`[data-controller*="look-up"][data-block-id="${data.block_id}"]`);
    
    if (lookupField) {
      const selectElement = lookupField.querySelector('select.slim-select');
      if (selectElement) {
        // Update the options
        updateLookupFieldOptions(selectElement, data.options, data);
      }
    }
  }
});

function updateLookupFieldOptions(selectElement, options, channelData) {
  // Get current selected values from SlimSelect instance if it exists
  let currentValues = [];
  if (selectElement.slimSelectInstance) {
    currentValues = selectElement.slimSelectInstance.getSelected() || [];
  } else {
    // Fallback to getting from selectedOptions
    currentValues = Array.from(selectElement.selectedOptions).map(option => option.value);
  }
  
  const newOptionsMap = new Map();
  options.forEach(option => {
    const key = `${option.group || ''}::${option.value || ''}`;
    const normalizedText = (option.text || '').trim();
    newOptionsMap.set(key, normalizedText);
  });
  
  const currentOptionsMap = new Map();
  const currentOptgroups = selectElement.querySelectorAll('optgroup');
  currentOptgroups.forEach(optgroup => {
    const groupName = optgroup.label || '';
    const currentOptions = optgroup.querySelectorAll('option');
    currentOptions.forEach(option => {
      const key = `${groupName}::${option.value || ''}`;
      const normalizedText = (option.textContent || '').trim();
      currentOptionsMap.set(key, normalizedText);
    });
  });
  
  let optionsChanged = false;
  let onlyTextChanged = false; 
  
  
  if (currentOptionsMap.size === 0 && newOptionsMap.size > 0) {
    optionsChanged = true;
  } else if (currentOptionsMap.size > 0) {
    
    if (newOptionsMap.size !== currentOptionsMap.size) {
      optionsChanged = true;
    } else {
      
      let structureChanged = false;
      let textChanged = false;
      
      
      for (const [key] of newOptionsMap) {
        if (!currentOptionsMap.has(key)) {
          structureChanged = true;
          break;
        }
      }
      
      if (!structureChanged) {
        
        for (const [key] of currentOptionsMap) {
          if (!newOptionsMap.has(key)) {
            structureChanged = true;
            break;
          }
        }
      }
      
      
      if (!structureChanged) {
        for (const [key, text] of newOptionsMap) {
          if (currentOptionsMap.get(key) !== text) {
            textChanged = true;
            break;
          }
        }
      }
      
      if (structureChanged) {
        optionsChanged = true;
      } else if (textChanged) {
        optionsChanged = true;
        onlyTextChanged = true; 
      }
    }
  }
  
  if (!optionsChanged) {
    return;
  }
  
  if (onlyTextChanged && selectElement.slimSelectInstance) {
    updateLookupFieldTextInPlace(selectElement, options, currentValues, channelData);
    return;
  }
  
  requestAnimationFrame(() => {
    selectElement.innerHTML = '';
    
    // Group options by group (workflow/board name)
    const groupedOptions = {};
    options.forEach(option => {
      if (!groupedOptions[option.group]) {
        groupedOptions[option.group] = [];
      }
      groupedOptions[option.group].push(option);
    });
    
    // Add grouped options
    Object.keys(groupedOptions).sort().forEach(groupName => {
      // Add optgroup
      const optgroup = document.createElement('optgroup');
      optgroup.label = groupName;
      selectElement.appendChild(optgroup);
      
      // Add options for this group
      groupedOptions[groupName].forEach(option => {
        const optionElement = document.createElement('option');
        optionElement.value = option.value;
        optionElement.textContent = option.text;
        if (currentValues.includes(option.value)) {
          optionElement.selected = true;
        }
        optgroup.appendChild(optionElement);
      });
    });
    
  // Destroy existing SlimSelect instance
    if (selectElement.slimSelectInstance) {
      selectElement.slimSelectInstance.destroy();
      selectElement.slimSelectInstance = null;
    }
    
  // Wait a bit for DOM to settle
    setTimeout(() => {
  
    let controllerInstance = selectElement.lookupController;
    
    if (!controllerInstance) {
      const lookupController = selectElement.closest('[data-controller*="look-up"]');
      if (lookupController) {
        
        const identifier = 'look-up';
        try {
          
          if (window.application) {
            controllerInstance = window.application.getControllerForElementAndIdentifier(lookupController, identifier);
          }
        } catch (e) {
        }
      }
    }
    
    // Check if this is a form field
    const isFormField = selectElement.closest('[data-form="true"]');
    
    // Reinitialize SlimSelect with the same configuration as the original
    const slimSelect = new SlimSelect({
      select: selectElement,
      settings: {
        closeOnSelect: false,
        allowDeselect: true,
      },
      events: isFormField ? {} : { 
        afterChange: (newValues) => {
          const isProgrammatic = selectElement._isProgrammaticChange;
          
          selectElement._isProgrammaticChange = false;
          
          if (controllerInstance && !isProgrammatic) {
            controllerInstance.save(selectElement);
          } else if (controllerInstance && isProgrammatic) {
            const selectedValues = Array.isArray(newValues) ? newValues : (newValues ? [newValues] : []);
            const currentSelection = selectedValues.sort().join(',');
            controllerInstance.previousSelections.set(selectElement, currentSelection);
          }
        }
      }
    });
    
    // Store reference for future use
    selectElement.slimSelectInstance = slimSelect;
    
    if (controllerInstance) {
      selectElement.lookupController = controllerInstance;
      
  
      const currentSelection = currentValues.sort().join(',');
      controllerInstance.previousSelections.set(selectElement, currentSelection);
    }
    
    // Set the selected values after initialization (mark as programmatic to prevent save)
    if (currentValues.length > 0) {
      setTimeout(() => {
        selectElement._isProgrammaticChange = true;
        slimSelect.setSelected(currentValues);
      }, 50);
    } else {
      
      selectElement._isProgrammaticChange = false;
    }
    
    
    if (channelData && channelData.block_type === 'task_block') {
      const { block_id, account_id, project_id, task_list_id, task_id } = channelData;
      
      if (account_id && project_id && task_list_id && task_id && block_id) {
        
        setTimeout(() => {
          const event = new CustomEvent('taskBlockUpdated', {
            detail: {
              block_id: block_id,
              account_id: account_id,
              project_id: project_id,
              task_list_id: task_list_id,
              task_id: task_id,
              action: 'update_value'
            }
          });
          document.dispatchEvent(event);
          
        
          const renderUrl = `/${account_id}/projects/${project_id}/task_lists/${task_list_id}/tasks/${task_id}/task_blocks/${block_id}/render_referencing_task_blocks`;
          
          if (typeof Rails !== 'undefined' && Rails.ajax) {
            Rails.ajax({
              url: renderUrl,
              type: 'GET',
              dataType: "script"
            });
          } else {
         
            fetch(renderUrl, {
              method: "GET",
              headers: {
                "Accept": "text/javascript",
                "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
              }
            })
              .then(response => {
                if (response.ok) {
                  return response.text();
                }
                throw new Error(`HTTP error! status: ${response.status}`);
              })
              .then(script => {
              
                eval(script);
              })
              .catch(error => {});
          }
        }, 200); // Wait a bit longer to ensure SlimSelect is fully initialized
      }
    }
    }, 50);
  });
}

function updateLookupFieldTextInPlace(selectElement, options, currentValues, channelData) {
  const slimSelectInstance = selectElement.slimSelectInstance;
  if (!slimSelectInstance) {
    return;
  }
  
  const valueToTextMap = new Map();
  options.forEach(option => {
    valueToTextMap.set(String(option.value), option.text);
  });
  
  requestAnimationFrame(() => {
    const optgroups = selectElement.querySelectorAll('optgroup');
    optgroups.forEach(optgroup => {
      const optionsInGroup = optgroup.querySelectorAll('option');
      optionsInGroup.forEach(optionEl => {
        const newText = valueToTextMap.get(optionEl.value);
        if (newText !== undefined && optionEl.textContent.trim() !== newText.trim()) {
          optionEl.textContent = newText;
        }
      });
    });
    
    try {
      const slimSelectContainer = selectElement.nextElementSibling;
      if (slimSelectContainer && slimSelectContainer.classList.contains('ss-main')) {
        const renderedOptions = slimSelectContainer.querySelectorAll('.ss-option');
        renderedOptions.forEach(renderedOption => {
          const optionValue = renderedOption.getAttribute('data-value');
          if (optionValue) {
            const newText = valueToTextMap.get(optionValue);
            if (newText !== undefined) {
              const textElement = renderedOption.querySelector('.ss-option-text') || 
                                 renderedOption.querySelector('span') ||
                                 renderedOption;
              
              if (textElement) {
                const firstTextNode = Array.from(textElement.childNodes).find(
                  node => node.nodeType === Node.TEXT_NODE
                );
                if (firstTextNode) {
                  firstTextNode.textContent = newText;
                } else {
                  textElement.textContent = newText;
                }
              }
            }
          }
        });
        
        const multiSelectedContainer = slimSelectContainer.querySelector('.ss-multi-selected');
        const multiSelectedValues = multiSelectedContainer ? 
          multiSelectedContainer.querySelectorAll('.ss-values .ss-value') : [];
        
        if (multiSelectedValues.length > 0) {
          multiSelectedValues.forEach(valueEl => {
            const optionValue = valueEl.getAttribute('data-value') || 
                               valueEl.getAttribute('data-id') ||
                               valueEl.closest('.ss-value')?.getAttribute('data-value');
            
            if (optionValue) {
              const newText = valueToTextMap.get(String(optionValue));
              if (newText !== undefined) {
                let valueSpan = valueEl.querySelector('.ss-value-text');
                if (!valueSpan) {
                  valueSpan = valueEl.querySelector('span:not(.ss-value-delete)');
                }
                if (!valueSpan) {
                  const textNodes = Array.from(valueEl.childNodes).filter(
                    node => node.nodeType === Node.TEXT_NODE || 
                           (node.nodeType === Node.ELEMENT_NODE && !node.classList.contains('ss-value-delete'))
                  );
                  if (textNodes.length > 0 && textNodes[0].nodeType === Node.ELEMENT_NODE) {
                    valueSpan = textNodes[0];
                  } else {
                    valueSpan = document.createElement('span');
                    valueSpan.className = 'ss-value-text';
                    const deleteBtn = valueEl.querySelector('.ss-value-delete');
                    if (deleteBtn) {
                      valueEl.insertBefore(valueSpan, deleteBtn);
                    } else {
                      valueEl.appendChild(valueSpan);
                    }
                  }
                }
                
                if (valueSpan) {
                  valueSpan.textContent = newText;
                }
              }
            }
          });
        } else {
          const singleSelectedContainer = slimSelectContainer.querySelector('.ss-single-selected');
          if (singleSelectedContainer && currentValues.length > 0) {
            const selectedText = valueToTextMap.get(String(currentValues[0]));
            if (selectedText) {
              let textElement = singleSelectedContainer.querySelector('.placeholder');
              
              if (!textElement) {
                textElement = singleSelectedContainer.querySelector('.ss-single');
              }
              
              if (!textElement) {
                const allElements = singleSelectedContainer.querySelectorAll('*');
                textElement = Array.from(allElements).find(el => {
                  return el.textContent.trim() && 
                         !el.classList.contains('ss-arrow') &&
                         el.tagName !== 'SPAN' || el.classList.contains('placeholder');
                });
              }
              
              if (!textElement) {
                const arrow = singleSelectedContainer.querySelector('.ss-arrow');
                const currentText = singleSelectedContainer.textContent.trim();
                if (currentText && currentText !== selectedText) {
                  if (arrow) {
                    singleSelectedContainer.innerHTML = '';
                    const newTextSpan = document.createElement('span');
                    newTextSpan.className = 'placeholder';
                    newTextSpan.textContent = selectedText;
                    singleSelectedContainer.appendChild(newTextSpan);
                    singleSelectedContainer.appendChild(arrow);
                  } else {
                    singleSelectedContainer.textContent = selectedText;
                  }
                }
              } else {
                textElement.textContent = selectedText;
              }
            }
          }
        }
        
        if (currentValues.length > 0) {
          const updateSelectedDisplay = () => {
            const multiSelectedContainer = slimSelectContainer.querySelector('.ss-multi-selected');
            const multiSelectedValues = multiSelectedContainer ? 
              multiSelectedContainer.querySelectorAll('.ss-values .ss-value') : [];
            
            if (multiSelectedValues.length > 0) {
              multiSelectedValues.forEach(valueEl => {
                const optionValue = valueEl.getAttribute('data-value') || 
                                   valueEl.getAttribute('data-id');
                if (optionValue) {
                  const newText = valueToTextMap.get(String(optionValue));
                  if (newText !== undefined) {
                    let valueSpan = valueEl.querySelector('.ss-value-text');
                    if (!valueSpan) {
                      valueSpan = valueEl.querySelector('span:not(.ss-value-delete)');
                    }
                    if (valueSpan) {
                      valueSpan.textContent = newText;
                    }
                  }
                }
              });
            } else {
              const singleSelectedContainer = slimSelectContainer.querySelector('.ss-single-selected');
              if (singleSelectedContainer) {
                const selectedText = valueToTextMap.get(String(currentValues[0]));
                if (selectedText) {
                  let textElement = singleSelectedContainer.querySelector('.placeholder') ||
                                   singleSelectedContainer.querySelector('.ss-single');
                  if (textElement) {
                    textElement.textContent = selectedText;
                  }
                }
              }
            }
          };
          
          updateSelectedDisplay();
          
          setTimeout(() => {
            try {
              selectElement._isProgrammaticChange = true;
              const valuesToRestore = [...currentValues];
              
              slimSelectInstance.setSelected([]);
              
              setTimeout(() => {
                slimSelectInstance.setSelected(valuesToRestore);
                
                setTimeout(() => {
                  updateSelectedDisplay();
                  selectElement._isProgrammaticChange = false;
                }, 10);
              }, 10);
            } catch (e) {
              selectElement._isProgrammaticChange = false;
            }
          }, 50);
        }
      }
    } catch (e) {
    }
  });
}
